@if (isPhotoBoothEnabled && allowPhotoBooth) {
  <button
    id="btnPhotoBooth"
    mat-mini-fab
    title="photo-booth"
    color="primary"
    class="photo-booth-button"
    (click)="showPhotoBoothModal()"
    [disabled]="photoBoothService.boothStartedByUser"
  >
    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.9987 3.83337C6.69786 3.83337 4.83203 5.69921 4.83203 8.00004C4.83203 10.3009 6.69786 12.1667 8.9987 12.1667C11.2995 12.1667 13.1654 10.3009 13.1654 8.00004C13.1654 5.69921 11.2995 3.83337 8.9987 3.83337ZM8.9987 10.5C7.61786 10.5 6.4987 9.38087 6.4987 8.00004C6.4987 6.61921 7.61786 5.50004 8.9987 5.50004C10.3795 5.50004 11.4987 6.61921 11.4987 8.00004C11.4987 9.38087 10.3795 10.5 8.9987 10.5Z"
        fill="#333333"
      />
      <path
        d="M15.666 2.16833H13.0352L11.4985 0.5L6.49852 0.504167L4.96935 2.16833H2.33268C1.41602 2.16833 0.666016 2.91833 0.666016 3.835V13.835C0.666016 14.7517 1.41602 15.5017 2.33268 15.5017H15.666C16.5827 15.5017 17.3327 14.7517 17.3327 13.835V3.835C17.3327 2.91833 16.5827 2.16833 15.666 2.16833ZM15.666 13.835H2.33268V3.835H5.70185L7.23102 2.17L10.7677 2.1675L12.3043 3.835H15.666V13.835Z"
        fill="#333333"
      />
    </svg>
  </button>
}

@if (isLoading) {
  <div class="loading-container">
    <app-loading></app-loading>
    <span class="font-s">{{ loadingText }}</span>
  </div>
}
